<template>
  <div id="app5">
      <Carousel_cards :vertical='false' :verticalS='false' :items='4' :rows='1' :controls='false' :texts="texts" :names="names"/>
  </div>
</template>

<script>
import Carousel_cards from './components/Carousel_cards';

export default {
  name: 'AppS',
  components: {
    Carousel_cards,
  },
  data: () => ({
   texts:[
      'Μόνο θετικά αποκόμισα από την επίσκεψη. Τα εξήγησε όλα με απλούς και κατανοητούς όρους, κέρδισε την εμπιστοσύνη μου από την αρχή. Τον συστήνω ανεπιφύλακτα.',
      'Θεωρώ ότι είναι καταρτισμένος ιατρός και ασχολείται εις βάθος με το πρόβλημα και το σημαντικότερο που πιστεύω ότι ακούει τον ασθενή.',
      'Αρχικά σε κερδίζει η καθαριότητα όπως και η συνέπεια στην ώρα! Ο γιατρός εξαιρετικός επιστήμονας με γνώση του αντικειμένου του! ',
      'Εξαιρετικός γιατρός, αλλά και άνθρωπος!!! Καταρτισμένος, ευγενέστατος και πολύ επεξηγηματικός. Τον συνιστώ ανεπιφύλακτα!',
      'Εξαιρετικός γιατρός! Έκλεισα ραντεβού για να κάνω έναν προληπτικό έλεγχο, δεν γινόταν να φύγω περισσότερο ευχαριστημένη. Μου εξήγησε τα πάντα λεπτομερώς!',
      'Ιδιαίτερα προσεκτικός στην κλινική εξέταση. Κατατοπιστικός στην επεξήγηση και στις κατευθυντήριες για την αντιμετώπιση του ζητήματος.',
      'Ένας γιατρός σωστός, ευγενικός, με ήθος, πρόσχαρος μα πάνω από όλα Άνθρωπος! Ανέλυσε εις βάθος την περίπτωση μου, κατανοητός και καθησυχαστικός.',
      'Εξαιρετικός γιατρός, φιλικός, προσηνής και επεξηγηματικός. Η εξέτασή του ήταν λεπτομερειακή και άνετη. Μου επεξήγησε αναλυτικά και με σαφήνεια ό,τι με απασχολούσε.',
      'Πολύ ευγενικός ήρεμος και άρτια ενημερωμένος. Πήρε λεπτομερώς Ιστορικό και μου εξήγησε την κατάλληλη αντιμετώπιση για το πρόβλημα μου.',
      'Άψογη εξυπηρέτηση! Ο γιατρός είναι ήρεμος, με υπομονή και επεξηγηματικός. Τον συστήνω ανεπιφύλακτα. Κέρδισε την εμπιστοσύνη μου'
    ],
    names:[
      'Μαρία Θ.',
      'Θωμάς Κ.',
      'Χαρά Α.',
      'Γεωργία Β.',
      'Γιάννα Π.',
      'Δημήτρης Κ.',
      'Αρετή Α.',
      'Μιχάλης Ι.',
      'Πολυάνθη Β.',
      'Άννα Π.'
    ]
    })
}
</script>
